export const categoriesTaskCardBodyCopy =
  "Set categories to organize and sort your team's expenses. Edit and add \
  custom rules for each category to include different fields in expense form \
  submissions.";

export const categoriesTaskCardProTipCopy =
  "After you get categories set up, check out Advanced Settings to \
  add project codes and map expense categories to their relevant \
  accounts in your accounting software.";
